module.exports = __webpack_public_path__ + "static/media/wN7S4QM5Cpqczjyd7ZDozM54kqMNrpKM6ZUac4vG.0838ed5b.webp";